export default "__VITE_ASSET__946ad985__"